<script setup>
import DashboardStatsUserCard from '@/Components/Dashboard/DashboardStatsUserCard'
import BadgeIcon from '@/icons/BadgeIcon'
import { formatDate } from '@/Mixins/FormatsDates'

import { computed } from 'vue'

const props = defineProps({
	organisation: {
		type: Object,
		default: null,
	},
})

const membership_level = computed(() => {
	if (props.organisation === null) return ''
	return props.organisation.membership_level.toUpperCase()
})

</script>
<template>
	<DashboardStatsUserCard :icon="BadgeIcon">
		<div class="text-center pt-4">
			<h1 class="text-2xl">{{ membership_level }} MEMBER</h1>
			<p class="bg-Orange rounded-xl p-1 px-2 mt-2 text-white text-xs mx-2">Member Since {{ formatDate(organisation.joined_date) }} </p>
		</div>
		
		<template #footer>
			<Button
				color="blue"
				variant="link"
				:href="'/organisations/' + organisation.id"
			>Manage Account</Button>
		</template>
	</DashboardStatsUserCard>
</template>